export const canViewHome = ({ error, association }) => !error && !association;
export const canViewWatchTab = (
  { error, association },
  { shouldEnableWatchTab },
) => shouldEnableWatchTab && !error && !association;
export const canViewServicesTab = (params) => canViewHome(params);
export const canViewServiceCertification = (params) => canViewHome(params);
export const canViewError = ({ error, association }) => error && !association;
export const canViewAssociate = ({ association }) => Boolean(association);
